import React from "react";
import { useState } from "react";
import {
  AiFillCloseCircle,
  AiFillMessage,
  AiFillNotification,
  AiOutlineBell,
} from "react-icons/ai";
import ChatModal from "./Chat/ChatModal";
import { io } from "socket.io-client";

import { useEffect } from "react";
import { useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { SocketData } from "../context/SocketContext";
const Footer = () => {
  const user = useSelector((state) => state.cartDetail);

  const [messages, setMessages] = useState([]);

  const { openChat, notifToArrive, setOpenChat } = SocketData();

  useEffect(() => {
    setMessages((prev) => [...prev, notifToArrive]);
  }, [notifToArrive]);

  return (
    <div className="footer_body">
      <div className="admin_message">
        <div className="chat">
          {(openChat || user?.notify === true) && (
            <ChatModal messages={messages} />
          )}
        </div>
        <div className="message-icon">
          <span></span>
          {openChat ? (
            <AiFillCloseCircle onClick={() => setOpenChat(false)} />
          ) : (
            <AiOutlineBell
              style={{ transform: "scaleX(-1)" }}
              onClick={() => setOpenChat(true)}
            />
          )}
        </div>
      </div>
      <p className="copyright">Amy Store 2022 &copy; All rights reserved</p>
    </div>
  );
};

export default Footer;
